import type { IToC } from "~/models/IToC";

export function useTocTitle(
  legalTextToc: MaybeRef<IToC>,
  columnCollapsed?: MaybeRef<boolean>
) {
  const { t } = useI18n();
  const tocTitle = computed(() => {
    const { section, title, legal_text_paragraphs } = unref(legalTextToc);
    if (unref(columnCollapsed)) {
      return section;
    }
    if (section || title) {
      return [section, title].filter((v) => !!v).join(": ");
    } else if (legal_text_paragraphs.length) {
      return t("legal_text.toc");
    }
    return "";
  });

  return tocTitle;
}
